import yup from "../../../utils/yup";

const emailLogoSchema = yup.object({
  src: yup.string().required("Add a logo to the header"),
  align: yup.string().oneOf(["left", "center", "right"]).default("center"),
  alt: yup.string().nullable(),
  proportionOfMaxWidth: yup.number().default(1),
  version: yup.number().default(1),
});

const headerTextSchema = yup.object({
  value: yup.string().nullable().default(""),
  align: yup.string().nullable().oneOf(["left", "center", "right"]).default("center"),
  color: yup.string().nullable(),
});

export const emailHeaderSchema = yup.object({
  fullWidth: yup.boolean().default(false),
  // Schema only uses split out values for padding
  paper_padding_side: yup.number().default(14),
  paper_padding_bottom: yup.number().default(14),
  paper_padding_top: yup.number().default(14),
  backgroundColor: yup.string().default("#ffffff"),
  logo: emailLogoSchema.nullable().default(null),
  text: headerTextSchema.nullable().default(null),
  hide_image_url_from_notification: yup.boolean().default(false),
});

export type EmailHeaderSchema = yup.InferType<typeof emailHeaderSchema>;
export type EmailHeaderProperties = yup.InferType<typeof emailHeaderSchema> & {
  // DB data will also potentially have this field
  padding?: number;
};
